import React, { Component, useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "@windmill/react-ui";
import { useDispatch, useSelector } from "react-redux";
import { BeatLoader } from "react-spinners";
import { DeleteReduxDataDeleteCti } from "../../api/Actions/ServiceCTI";

import { CreateCtiTicket } from "../../api/Actions/ServiceCTI";
import toast, { Toaster } from "react-hot-toast";

const TestTicketModal = () => {
  const dispatch = useDispatch();
  const [DisableCreateButton, setDisableCreateButton] = useState(true);
  const [LoadingCreate, setLoadingCreate] = useState(false);
  let [FormData, setFormData] = useState({
    destination: "",
    subject: "",
    description: "",
  });

  // const getOrganization = useSelector(
  //   (state) => state.Organization.getAllOrganization
  // );

  const TestTicket = useSelector(
    (state) => state.CtiCredential.CreateCtiTicket
  );

  const OpenTestTicketModal = useSelector(
    (state) => state.ReduxState.TestTicketModal
  );

  const ctiType = useSelector((state) => state.ReduxState.ctiType);

  // get ticket field data
  const testTicketModal = () => {
    dispatch({ type: "set", TestTicketModal: !OpenTestTicketModal });
  };

  //handle save update field
  const testCreateTicket = () => {
    setDisableCreateButton(true);
    setLoadingCreate(true);
    const org = localStorage.getItem("orgUuid");

    const dataReq = {
      orgUuid: org,
      // uId: decode["id"],
      destination: FormData["destination"],
      subject: FormData["subject"],
      description: FormData["description"],
    };
    console.log(ctiType, dataReq, "DATA DATAREQ");
    dispatch(CreateCtiTicket(ctiType, dataReq));
  };

  //handle save update field
  const handleNested = (fieldName, selected, type) => {
    switch (type) {
      case "input":
        setFormData((prevState) => ({
          ...prevState,
          [fieldName]: selected.target.value,
        }));
        break;

      default:
        setFormData((prevState) => ({
          ...prevState,
          [fieldName]: selected.target.value,
        }));
        break;
    }
  };
  useEffect(() => {
    if (TestTicket !== false) {
      if (TestTicket.success === true) {
        testTicketModal();
        toast("Ticket Created");
        // Swal.fire({
        //   icon: "success",
        //   title: "Ticket Field Updated",
        // });
      } else {
        toast("Please check again your input");
        // Swal.fire({
        //   icon: "error",
        //   title: "Please check required fields",
        // });
      }
      setFormData({
        destination: "",
        subject: "",
        description: "",
      });
      setLoadingCreate(false);
    }
  }, [TestTicket]);

  // console.log(TestTicket, "respond create ticket");
  // console.log(TestTicket);

  useEffect(() => {
    if (FormData.description && FormData.destination && FormData.subject) {
      setDisableCreateButton(false);
    } else {
      setDisableCreateButton(true);
    }
  }, [FormData]);

  return (
    <>
      <Modal
        className="bg-white w-1/2 h-3/4 p-10 rounded-xl overflow-y-auto"
        isOpen={OpenTestTicketModal}
        onClose={testTicketModal}
      >
        <ModalHeader>
          <p className="font-bold text-2xl text-center">Test Create Ticket</p>
          <hr />
        </ModalHeader>
        <ModalBody>
          <form>
            <div className="relative">
              <label>Destination</label>
              <input
                onChange={(selected) =>
                  handleNested("destination", selected, "input")
                }
                type="text"
                className="resize-none mb-2 w-full h-10 border-gray-300 border rounded focus:ring-0 outline-none"
              ></input>
            </div>
            <div className="relative">
              <label>Subject</label>
              <input
                onChange={(selected) =>
                  handleNested("subject", selected, "input")
                }
                type="text"
                className="resize-none mb-2 w-full h-10 border-gray-300 border rounded focus:ring-0 outline-none"
              ></input>
            </div>
            <div className="relative">
              <label>Description</label>
              <textarea
                onChange={(selected) =>
                  handleNested("description", selected, "input")
                }
                className="resize-none w-full mb-2 h-40 border-gray-300 border rounded focus:ring-0 outline-none"
              ></textarea>
            </div>
            <div className="flex mt-10">
              <button
                disabled={DisableCreateButton}
                onClick={(e) => testCreateTicket(e)}
                type="button"
                className={
                  (DisableCreateButton
                    ? "bg-blue-500 cursor-not-allowed"
                    : "bg-main-blue") +
                  " mx-auto w-40 rounded-lg h-10 text-white font-bold"
                }
              >
                {LoadingCreate ? (
                  <BeatLoader
                    className="mx-auto my-auto"
                    color="#FFFFFF"
                    size={8}
                  />
                ) : (
                  "Create"
                )}
              </button>
            </div>
          </form>
        </ModalBody>
        <Toaster
          position="center"
          reverseOrder={false}
          gutter={8}
          containerClassName=""
          containerStyle={{}}
          toastOptions={{
            // Define default options
            className: "",
            duration: 10000,
            style: {
              background: "#363636",
              color: "#fff",
            },

            // Default options for specific types
            success: {
              duration: 3000,
              theme: {
                primary: "green",
                secondary: "black",
              },
            },
          }}
        />
      </Modal>
    </>
  );
};

export default TestTicketModal;
